export default __webpack_public_path__ + "static/media/com-rocket.16a6c52e.mp4";